// Google Analytics Configuration
// Replace 'G-XXXXXXXXXX' with your actual Google Analytics 4 Measurement ID
// You can find this in your Google Analytics account under Admin > Data Streams

export const GA_CONFIG = {
  // Replace this with your actual GA4 Measurement ID
  TRACKING_ID: process.env.REACT_APP_GA_TRACKING_ID || 'G-QH34QHYRXM',
  
  // Development mode - set to false in production
  DEBUG_MODE: process.env.NODE_ENV === 'development',
  
  // Custom dimensions (optional)
  CUSTOM_DIMENSIONS: {
    USER_TYPE: 'user_type',
    PAGE_SECTION: 'page_section',
  }
};

// Instructions for setup:
// 1. Go to https://analytics.google.com/
// 2. Create a new GA4 property for your website
// 3. Go to Admin > Data Streams > Web
// 4. Copy your Measurement ID (starts with G-)
// 5. Create a .env.local file in your project root
// 6. Add: REACT_APP_GA_TRACKING_ID=G-YOUR-ACTUAL-ID
// 7. Restart your development server
